import type { ReactNode } from 'react'

import { Chip } from '@/src/elements/chip/Chip'
import { useTranslate } from '@/src/lang/useTranslate'

import { useConversationsListStore } from '../../stores/useConversationsListStore'

export const UnreadConversationsToggle = (): ReactNode => {
  const { t } = useTranslate()

  const { unread, setUnread } = useConversationsListStore()

  return (
    <>
      <Chip
        variant="flat"
        colors={unread ? 'default' : 'success'}
        text={t('word.all.feminine')}
        onPress={() => setUnread(false)}
        className="native:min-w-12 web:grow-0 web:basis-auto"
      />
      <Chip
        variant="flat"
        colors={unread ? 'success' : 'default'}
        text={t('conversations.unread')}
        onPress={() => setUnread(true)}
        className="native:max-w-20 web:grow-0 web:basis-auto"
      />
    </>
  )
}
